/** @format */

import { SearchOutlined } from '@ant-design/icons';
import { AutoComplete, Input } from 'antd';
import useMergedState from 'rc-util/es/hooks/useMergedState';
import React, { useRef } from 'react';

// import classNames from 'classnames';
import styles from './index.less';

const HeaderSearch = props => {
  const {
    styleObj,
    className,
    defaultValue,
    onVisibleChange,
    placeholder,
    open,
    defaultOpen,
    ...restProps
  } = props;

  const inputRef = useRef(null);

  const [value, setValue] = useMergedState(defaultValue, {
    value: props.value,
    onChange: props.onChange,
  });

  const [searchMode, setSearchMode] = useMergedState(defaultOpen ?? false, {
    value: props.open,
    onChange: onVisibleChange,
  });

  return (
    <div
      className={'headerSearch'}
      style={styleObj}
      onClick={() => {
        setSearchMode(true);

        if (inputRef.current) {
          inputRef.current.focus();
        }
      }}
      onTransitionEnd={({ propertyName }) => {
        if (propertyName === 'width' && !searchMode) {
          if (onVisibleChange) {
            onVisibleChange(searchMode);
          }
        }
      }}>
      <SearchOutlined
        key="Icon"
        className={'search-icon'}
        style={{
          cursor: 'pointer',
        }}
      />
      <AutoComplete
        key="AutoComplete"
        className={['input', searchMode ? 'show' : '']}
        value={value}
        style={{
          height: 28,
          marginTop: -6,
        }}
        options={restProps.options}
        onChange={setValue}>
        <Input
          ref={inputRef}
          defaultValue={defaultValue}
          aria-label={placeholder}
          placeholder={placeholder}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              if (restProps.onSearch) {
                restProps.onSearch(value);
              }
            }
          }}
          onBlur={() => {
            if (inputRef?.current?.state?.value === '') {
              setSearchMode(false);
            }
          }}
        />
      </AutoComplete>
    </div>
  );
};

export default HeaderSearch;
